import { Empty } from 'antd';
import { IConfigProvider } from 'npm-wlac'; // 引入ConfigProvider全局化配置
import { useIntl } from 'umi';
const Layouts = props => {
  const intl = useIntl();
  return (
    <IConfigProvider
      locale={intl.antd}
      renderEmpty={() => <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />}
    >
      {props.children}
    </IConfigProvider>
  );
};

export default Layouts;
